<template lang="pug">
LoaderOverlay(:loading="loading")
  form
    .row
      .col-md-12
        p.text-muted.small
          span.required-asterisk *
          |  indicates required field

    .row
      .col-md-12
        .form-group
          Label(text="Title" input-id="title" required)
          Input#title(v-model="location.title" required)

    .row
      .col-md-12
        hr

    .row
      div(:class="columnClass")
        .row
          .col-md-12
            .form-group
              Label.title(text="Address 1" input-id="street1" required)
              Input#street1(v-model="location.street1" required)

            .form-group
              Label(text="Address 2" input-id="street2")
              Input#street2(v-model="location.street2")

        .row
          .col-md-6
            .form-group
              Label(text="City" input-id="city" required)
              Input#city(v-model="location.city" required)

          .col-md-2
            .form-group
              Label(text="State" input-id="state" required)
              Input#state(v-model="location.state" required)

          .col-md-4
            .form-group
              Label(text="Zip" input-id="zip" required)
              Input#zip(v-model="location.zip" required)

      div(:class="columnClass")
        .form-group
          Label(text="Phone 1" input-id="phone1")
          Input#phone1(v-model="location.phone1" type="tel")

        .form-group
          Label(text="Phone 2" input-id="phone2")
          Input#phone2(v-model="location.phone2" type="tel")

        .form-group
          Label(text="Fax" input-id="fax")
          Input#fax(v-model="location.fax" type="tel")

    .row
      .col-md-12
        hr

    .row
      .col-md-6
        .form-group
          Label(text="Email" input-id="email")
          Input#email(v-model="location.email" type="email")

      .col-md-6
        .form-group
          Label(text="Website" input-id="website")
          Input#website(v-model="location.website")

    .row
      .col-md-12
        .form-group
          Label(text="Description" input-id="description")
          TextareaInput#description(v-model="location.description" type)

    .row.text-nowrap(v-if="showButtons")
      .col-sm-12
        button.btn.btn-primary(type="submit" @click.prevent="save") Save
        router-link.btn.btn-link.text-muted(to="/locations") Cancel
</template>

<script>
  import { mapStores, mapState } from 'pinia'
  import { useLocationStore } from '@/stores/location'
  import Input from '@/components/shared/input.vue'
  import Label from '@/components/shared/label.vue'
  import LoaderOverlay from '@/components/shared/loader_overlay.vue'
  import TextareaInput from '@/components/shared/textarea_input.vue'

  export default {
    components: {
      Input,
      Label,
      LoaderOverlay,
      TextareaInput
    },

    props: {
      postSaveAction: {
        type: Function,
        default: function() { this.$router.push('/locations') }
      },

      showButtons: {
        type: Boolean,
        default: true
      },

      twoColumnLayout: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        loading: false
      }
    },

    computed: {
      ...mapStores(useLocationStore),
      ...mapState(useLocationStore, ['location']),

      columnClass() {
        const cssClass = this.twoColumnLayout ? 'col-md-6' : 'col-md-12'

        return { [cssClass]: true }
      }
    },

    methods: {
      async save() {
        this.loading = true

        await this.locationStore.save().then((resp) => {
          this.postSaveAction(resp)
        }).catch(() => {})

        this.loading = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .required-asterisk {
    color: #d9534f;
    font-weight: bold;
  }
</style>
